import { render, staticRenderFns } from "./legendOtherType.vue?vue&type=template&id=f3de2742&scoped=true"
import script from "./legendOtherType.vue?vue&type=script&lang=ts"
export * from "./legendOtherType.vue?vue&type=script&lang=ts"
import style0 from "./legendOtherType.vue?vue&type=style&index=0&id=f3de2742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3de2742",
  null
  
)

export default component.exports